import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getAgenticWorkflowDetails } from '../../api/getAgenticWorkflowDetails';
import { queryKeys } from '../queryKeys';

export type UseGetAgenticWorkflowDetailsParams = {
    id: string;
    startDate: Date;
    endDate: Date;
    callStatus?: string;
    partyStage?: string;
    callDirection?: string;
    disposition?: string;
    search?: string;
    perPage?: number;
    currentPage?: number;
    sortOrder?: 'asc' | 'desc';
    isRefetchEnabled?: boolean;
};

export const useGetAgenticWorkflowDetails = (props: UseGetAgenticWorkflowDetailsParams) => {
    const { data, isLoading, refetch, ...rest } = useQuery({
        queryKey: queryKeys.agenticWorkflowDetails(props),
        queryFn: () => getAgenticWorkflowDetails(props),
        enabled: !!(props.id && props.startDate && props.endDate),
        placeholderData: keepPreviousData,
        refetchInterval: (query) => {
            return props.isRefetchEnabled && query.state.data?.status === 'ACTIVE' ? 10000 : false;
        },
    });

    return {
        agenticWorkflowDetails: data && {
            ...data,
            callStatistic: data.callStatistic && {
                ...data.callStatistic,
                // Pending
                // pending: 8,
                // overDue: 4,
                // // In progress
                // dialing: 3,
                // ringing: 6,
                // inProgress: 4,
                // // Unable to contact
                // failed: 5,
                // busy: 4,
                // noAnswer: 7,
                // badNumber: 2,
                // unableToContact: 18,
                // // Contact
                // userAbandoned: 6,
                // agentAbandoned: 3,
                // completed: 11,
                // contacted: 20,
                // // Voicemail
                // voicemailSuccess: 9,
                // voicemailFailed: 3,
                // voicemail: 12,
                // // Transfer
                // transferCompleted: 5,
                // transferFailed: 2,
                // transferInProgress: 1,
                // noAgentsAvailable: 2,
                // agentRejected: 1,
                // transferUserAbandoned: 1,
                // humanOnCall: 2,
                // transfer: 14,
                // // Direction
                // outbound: 55,
                // inbound: 30,
                // manual: 15,
                // // Disposition
                // dispositionBreakdown: {
                //     QUALIFY: 12,
                //     INTERESTED: 8,
                //     CALLBACK: 6,
                //     UNDETERMINED: 10,
                //     UNQUALIFIED: 5,
                //     NOT_INTERESTED: 4,
                // },
                // total: 100,
            },
        },
        isLoadingAgenticWorkflowDetails: isLoading,
        refetchAgenticWorkflowDetails: refetch,
        ...rest,
    };
};
